export interface SessionExpiryController {
  beginHandling: () => boolean;
  rearm: () => void;
}

type CompleteExpiredSessionOptions = {
  signOut: (options: { redirectUrl: string }) => Promise<unknown>;
  setActiveSession: (session: null) => Promise<unknown>;
  redirectUrl: string;
};

export async function completeExpiredSession({
  signOut,
  setActiveSession,
  redirectUrl,
}: CompleteExpiredSessionOptions): Promise<boolean> {
  try {
    await signOut({ redirectUrl });
    return true;
  } catch {
    try {
      await setActiveSession(null);
      return true;
    } catch {
      return false;
    }
  }
}

export function createSessionExpiryController(): SessionExpiryController {
  let handling = false;

  return {
    beginHandling: () => {
      if (handling) return false;
      handling = true;
      return true;
    },
    rearm: () => {
      handling = false;
    },
  };
}
